export const stringHasURL = (value: string) =>
  value.includes("http") || value.includes("/");
